import { OidcClient } from 'oidc-client-ts';

// these values are loaded into `process.env` via webpack and the `oauthCredentials.js`
// file at the root of this repo.
const oauthClientId = process.env.OAUTH_CLIENT_ID; // eslint-disable-line no-undef
const redirectUri = process.env.OAUTH_REDIRECT_URI; // eslint-disable-line no-undef
const discoveryHost = process.env.OAUTH_DISCOVERY_HOST; // eslint-disable-line no-undef

function createDefaultOidcClient() {
    return new OidcClient({
        authority: discoveryHost,
        client_id: oauthClientId,
        scope: 'me central.read central.write',
        redirect_uri: redirectUri,
        response_mode: 'query',
        response_type: 'code',
    });
}

/**
 * This encapsulates the the interaction the alli central oauth login flow
 * using https://www.npmjs.com/package/@openid/appauth
 */
export default class OAuth {
    constructor(client) {
        this.client = client || createDefaultOidcClient();
    }

    /**
     * Start the login flow by redirectint he user to central to complete the login dance.
     *
     * @return Promise<string> returns a promise that resolve to the url to which the user should be redirected
     */
    redirectToLogin(alliRedirect) {
        const state = {
            alliRedirect,
        };

        return this.client.createSigninRequest({ state }).then(request => request.url);
    }

    /**
     * Complete the login flow.
     *
     * This is a little convoluted, but the gist of this is that the notifier's
     * listener is invoked
     *
     * @param string url The current url as a string (we pull code and state from the query with this)
     * @return Promise<object> a provise with the token info + redirect
     */
    completeLogin(url) {
        return this.client.processSigninResponse(url).then(response => ({
            access_token: response.access_token,
            token_type: response.token_type,
            refresh_token: response.refresh_token,
            expires_in: response.expires_in,
            alliRedirect: response.userState.alliRedirect,
        }));
    }

    /**
     * @param string refreshToken the stored refresh token
     * @return Promise<object> a promise that resolves to a token response
     */
    refreshAccessToken(refreshToken) {
        return this.client
            .useRefreshToken({
                state: {
                    refresh_token: refreshToken,
                },
            })
            .then(response => ({
                access_token: response.access_token,
                token_type: response.token_type,
                refresh_token: response.refresh_token,
                expires_in: response.expires_in,
            }));
    }
}
